export default __webpack_public_path__ + "static/media/460.d716bda1.png";